<div class="app">
	<router-outlet></router-outlet>
</div>